import { useGetURL, useUrlFriendlyToParameters } from 'helpers/urlFriendly'
import { useGetFunctionOCSUrl } from 'helpers/utils'
import React from 'react'

export default function Redirect({redirection}) {
  const getOCSURL = useGetFunctionOCSUrl()
  const getUrl = useGetURL()
  const params = useUrlFriendlyToParameters();
  let paramsURL = { ...params }
  //console.log(window.location.href)
  //console.log(paramsURL)
  //console.log(redirection)
  //console.log(paramsURL)

  //medal
  let urlMedal = getUrl(paramsURL, 'medal')
  //console.log("Medal", urlMedal)
  urlMedal = getOCSURL(urlMedal, 'medal', paramsURL) // checking OCS URL

  //scheduleByNoc
  let urlScheduleByNoc = getUrl(paramsURL, 'schedulebynoc')
  //console.log("Schedule by NOC", urlScheduleByNoc)
  urlScheduleByNoc = getOCSURL(urlScheduleByNoc, 'schedulebynoc', paramsURL) // checking OCS URL

  //medallistsByNoc
  let urlMedallistsByNoc = getUrl(paramsURL, 'medallistsbynoc')
  //console.log("Medal by NOC", urlMedallistsByNoc)
  urlMedallistsByNoc = getOCSURL(urlMedallistsByNoc, 'medallistsbynoc', paramsURL) // checking OCS URL

  //schedule
  let urlSchedule = getUrl(paramsURL, 'schedule')
  //console.log("Schedule", urlSchedule)
  urlSchedule = getOCSURL(urlMedal, 'schedule', paramsURL) // checking OCS URL

  let url = urlSchedule
  if (redirection === 'schedule' && !url && paramsURL.mirs_discipline && !paramsURL.mirs_noc) {
    paramsURL.mirs_noc = paramsURL?.mirs_discipline
    paramsURL.mirs_discipline = undefined
    urlMedallistsByNoc = getUrl(paramsURL, 'medallistsbynoc')
    //console.log(paramsURL)
    //console.log(urlMedallistsByNoc)
    url =  getOCSURL(urlMedallistsByNoc, 'medallistsbynoc', paramsURL) // checking OCS URL
    //console.log("URLLL", url)
  }

    if (redirection === 'medal') {
        url = urlMedal

    } else if(redirection === 'scheduleByNoc') {
        url = urlScheduleByNoc

    } else if(redirection === 'medallistsByNoc') {
        url = urlMedallistsByNoc
    }

  //console.log("Medal", urlMedal)
  //console.log("Schedule by NOC", urlScheduleByNoc)
  //console.log("Medal by NOC", urlMedallistsByNoc)
  //console.log("Schedule", urlSchedule)
  window.location.reload(true)
  return <></>
}






